import React from "react"

type Props = {
  className?: string
}

const OperationsIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.9999 12.5V13.3333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9999 16.667V17.5003"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8334 13.7503L13.5834 14.167"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4167 15.8333L17.1667 16.25"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8334 16.25L13.5834 15.8333"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4167 14.167L17.1667 13.7503"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1666 13.833C16.8333 14.4997 16.8333 15.4997 16.1666 16.1663C15.4999 16.833 14.4999 16.833 13.8333 16.1663C13.1666 15.4997 13.1666 14.4997 13.8333 13.833C14.4999 13.1663 15.4999 13.1663 16.1666 13.833"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 4.33301C13.9167 5.74967 13.9167 7.99967 12.5 9.33301C11.0833 10.6663 8.83333 10.7497 7.49999 9.33301C6.16666 7.91634 6.08333 5.66634 7.49999 4.33301C8.91666 2.99967 11.0833 2.99967 12.5 4.33301"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33325 16.667C3.33325 14.5837 4.99992 12.917 7.08325 12.917H9.24992"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default OperationsIcon
